/**
 * Minimal HTML escaper used when injecting user-controlled values into a
 * print template that is then written to a popup window via `document.write`.
 * Prevents stored-XSS through fields like `buyer_name` / `recipient_name`
 * (those are filled by external customers, so we MUST treat them as untrusted).
 */
export function escapeHtml(value) {
  if (value == null) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
